/* tools.svelte.ts generated by Svelte v5.55.4 */
import * as $ from 'svelte/internal/client';

export const TOOLS = [
	{ id: "hand", label: "Hand", cursor: "grab", key: "1" },
	{ id: "point", label: "Point", cursor: "crosshair", key: "2" },
	{ id: "freehand", label: "Draw", cursor: "crosshair", key: "3" },
	{ id: "line", label: "Line", cursor: "crosshair", key: "4" },
	{ id: "rect", label: "Rect", cursor: "crosshair", key: "5" },
	{ id: "fill", label: "Fill", cursor: "crosshair", key: "6" },
	{
		id: "eraser",
		label: "Eraser",
		cursor: "not-allowed",
		key: "7"
	}
];

class ToolStore {
	#activeTool = $.state("hand");

	get activeTool() {
		return $.get(this.#activeTool);
	}

	set activeTool(value) {
		$.set(this.#activeTool, value, true);
	}

	#color = $.state("#FFFF00");

	get color() {
		return $.get(this.#color);
	}

	set color(value) {
		$.set(this.#color, value, true);
	}

	#opacity = $.state(100);

	get opacity() {
		return $.get(this.#opacity);
	}

	set opacity(value) {
		$.set(this.#opacity, value, true);
	}

	#eraserSize = $.state(1);

	get eraserSize() {
		return $.get(this.#eraserSize);
	}

	set eraserSize(value) {
		$.set(this.#eraserSize, value, true);
	}

	#brushSize = $.state(1);

	get brushSize() {
		return $.get(this.#brushSize);
	}

	set brushSize(value) {
		$.set(this.#brushSize, value, true);
	}

	get cssColor() {
		return this.color;
	}

	get accent() {
		const hex = this.color.replace("#", "");
		let r = parseInt(hex.substring(0, 2), 16);
		let g = parseInt(hex.substring(2, 4), 16);
		let b = parseInt(hex.substring(4, 6), 16);

		r /= 255;
		g /= 255;
		b /= 255;

		const max = Math.max(r, g, b),
			min = Math.min(r, g, b);

		let h = 0, s = 0, l = (max + min) / 2;

		if (max !== min) {
			const d = max - min;

			s = l > 0.5 ? d / (2 - max - min) : d / (max + min);

			if (max === r) h = ((g - b) / d + (g < b ? 6 : 0)) / 6; else if (max === g) h = ((b - r) / d + 2) / 6; else h = ((r - g) / d + 4) / 6;
		}

		l = Math.max(l, 0.55);
		s = Math.max(s, 0.4);

		function hue2rgb(p, q, t) {
			if (t < 0) t += 1;
			if (t > 1) t -= 1;
			if (t < 1 / 6) return p + (q - p) * 6 * t;
			if (t < 1 / 2) return q;
			if (t < 2 / 3) return p + (q - p) * (2 / 3 - t) * 6;

			return p;
		}

		const q = l < 0.5 ? l * (1 + s) : l + s - l * s;
		const p = 2 * l - q;
		const ro = Math.round(hue2rgb(p, q, h + 1 / 3) * 255);
		const go = Math.round(hue2rgb(p, q, h) * 255);
		const bo = Math.round(hue2rgb(p, q, h - 1 / 3) * 255);

		return `#${ro.toString(16).padStart(2, "0")}${go.toString(16).padStart(2, "0")}${bo.toString(16).padStart(2, "0")}`;
	}

	get argbColor() {
		const hex = this.color.replace("#", "");
		const a = Math.round(this.opacity / 100 * 255);

		return "#" + a.toString(16).padStart(2, "0").toUpperCase() + hex.toUpperCase();
	}

	get toolDef() {
		return TOOLS.find((t) => t.id === this.activeTool);
	}

	get hint() {
		const hints = {
			hand: "Drag to pan the map. [1]",
			point: "Click to place, click existing to edit. [2]",
			freehand: "Click and drag to paint tiles. [3]",
			line: "Click start, then click end. [4]",
			rect: "Click and drag to draw a rectangle outline. [5]",
			fill: "Click to flood-fill a connected region. [6]",
			eraser: "Click or drag to remove markers. [7]"
		};

		return hints[this.activeTool];
	}

	setTool(id) {
		this.activeTool = id;
	}
}

export const toolStore = new ToolStore();